import React from "react";
import sidebarStyle from "./UpdateSidebarMenu.module.css";

const SidebarItem = ({ 
  text, 
  icon, 
  active, 
  completed, 
  onClick, 
  showSteps = false 
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick(); // This will call the parent's onClick with the item
    }
  };

  return (
    <div 
      className={`${sidebarStyle.sidebarItem} ${active ? sidebarStyle.active : ""} ${completed ? sidebarStyle.completed : ""}`}
      onClick={handleClick}
    >
      {/* Step Circle - Only show if showSteps is true */}
      {showSteps && (
        <div className={sidebarStyle.stepContainer}>
          <div className={`${sidebarStyle.stepCircle} ${active ? sidebarStyle.stepActive : ""} ${completed ? sidebarStyle.stepCompleted : ""}`} />
        </div>
      )}
      
      {/* Icon and Text */}
      <div className={sidebarStyle.stepContent}>
        {/* {icon && <span className={sidebarStyle.stepIcon}>{icon}</span>} */}
        <span className={sidebarStyle.stepText}>{text}</span>
      </div>
    </div>
  );
};

export default SidebarItem;